import React from "react";
import { useScrollTrigger, useTheme } from "@mui/material";

const ScrollHandler = (props) => {
  const theme = useTheme();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 10, // Un poco de margen antes de cambiar
    target: props.window ? window() : undefined,
  });

  return React.cloneElement(props.children, {
    style: {
      backgroundColor: trigger ? "rgba(255, 255, 255, 0.8)" : "transparent", // Semitransparente
      backdropFilter: trigger ? "blur(12px)" : "none", // Efecto vidrio
      color: theme.palette.text.primary,
      transition: "all 0.3s ease-in-out",
      boxShadow: trigger ? "0px 4px 20px rgba(0,0,0,0.05)" : "none", // Sombra suave solo al bajar
      padding: trigger ? "5px 0px" : "15px 0px", // Animación de tamaño
      borderBottom: trigger ? `1px solid ${theme.palette.divider}` : "none",
    },
  });
};

const ScrollToColor = (props) => {
  return <ScrollHandler {...props}>{props.children}</ScrollHandler>;
};

export default ScrollToColor;